import { isDefined } from "@clipboard-health/util-ts";
import { Button } from "@src/appV2/redesign/components/Button";
import { ShiftBottomSheetBookabilityCriteriaCard } from "@src/appV2/redesign/Shift/BottomSheet/BookabilityCriteriaCard";
import { formatTime } from "@src/appV2/redesign/utils/formatTime";

interface WorkerShiftDetailsUpdateEtaCardProps {
  updatedEta?: Date;
  workplaceTimezone: string;
  onUpdateEta: () => void;
}

export function UpdateEtaCard(props: WorkerShiftDetailsUpdateEtaCardProps) {
  const { updatedEta, workplaceTimezone, onUpdateEta } = props;

  const isUpdatedEtaAvailable = isDefined(updatedEta);

  const updatedEtaTimeFormatted = isUpdatedEtaAvailable
    ? formatTime(updatedEta, workplaceTimezone)
    : undefined;

  function getTitle() {
    if (isUpdatedEtaAvailable) {
      return `You've updated your ETA to ${updatedEtaTimeFormatted}.`;
    }

    return "Running late?";
  }

  function getDescription() {
    if (isUpdatedEtaAvailable) {
      return `If you're running later than ${updatedEtaTimeFormatted}, update your ETA again or you may lose the shift.`;
    }

    return "If you are running late, you should update your ETA in app, or you may lose the shift";
  }

  function getIllustrationType() {
    if (isUpdatedEtaAvailable) {
      return "check-warning";
    }

    return "clock-warning";
  }

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="warning"
      title={getTitle()}
      description={getDescription()}
      illustrationType={getIllustrationType()}
      footer={
        <Button fullWidth variant="contained" size="medium" onClick={onUpdateEta}>
          Update ETA
        </Button>
      }
    />
  );
}
